export const BANKID_TEST_IDS = {
  mobileBankIdButton: "mobile-bank-id-button",
  mobileBankIdTestFlowButton: "mobile-bank-id-test-flow-button",
  ssnInput: "bank-id-ssn-input",
  bankIdContinueButton: "bank-id-continue-button",
};
